var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "155.75px",
    height: "155.75px",
    viewBox: "0 0 155.75 155.75",
    enableBackground: "new 0 0 155.75 155.75",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "info"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "icons"
  }, /*#__PURE__*/React.createElement("path", {
    id: "exit",
    d: "M109.026,77.875l40.051-40.05c8.896-8.9,8.896-22.25,0-31.15c-8.9-8.9-22.25-8.9-31.15,0l-40.051,40.05 L37.827,6.675c-8.9-8.9-22.25-8.9-31.15,0c-8.899,8.9-8.899,22.25,0,31.15l40.05,40.05l-40.05,40.05 c-8.899,8.9-8.899,22.25,0,31.15c4.449,4.45,10.013,6.675,15.574,6.675c5.563,0,11.125-2.225,15.576-6.675l40.049-40.05 l40.051,40.05c4.449,4.45,10.013,6.675,15.574,6.675c5.563,0,11.125-2.225,15.576-6.675c8.896-8.9,8.896-22.25,0-31.15 L109.026,77.875z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.ff0f66882bfb389afa3fbfea24cb6a7a.svg";
export { ForwardRef as ReactComponent };